import React from "react";
import { useRouteMatch } from "react-router-dom";
import axios from "axios";
import NewsCard from "./NewsCard";
import FilterDialog from "./FilterDialog";
import Loading from "../Common/Loading";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FilterListIcon from "@material-ui/icons/FilterList";

const useStyles = makeStyles(() => ({
  cardsContainer: {
    //border: "1px solid",
    //padding: "0 1rem",
    maxWidth: "100vw",
  },
}));

export default function News({ setCurrentPath }) {
  const [data, setData] = React.useState([]);
  const [newsFilterOpen, setNewsFilteropen] = React.useState(false);
  const classes = useStyles();
  const match = useRouteMatch();
  //console.log("match: ", match);

  const getAllNews = () => {
    axios
      .get("https://crypto-prediction-nac.herokuapp.com/get-news")
      .then((res) => {
        console.log("news data: ", res.data.data);
        setData(res.data.data);
      })
      .catch((err) => console.log("news error: ", err.message));
  };

  React.useEffect(() => {
    setCurrentPath(match.path);
    getAllNews();
  }, []);

  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid container direction="column">
          <Grid container style={{ padding: "1rem" }}>
            <Typography variant="h5" color="secondary" style={{ flex: 1 }}>
              News
            </Typography>
            {data.length > 0 && (
              <Button
                size="small"
                color="primary"
                onClick={() => setNewsFilteropen(true)}
                endIcon={<FilterListIcon fontSize="small" />}
              >
                Filter
              </Button>
            )}
          </Grid>
          {data.length === 0 && <Loading />}
          {data.length > 0 && (
            <Grid
              container
              justifyContent="center"
              item
              spacing={2}
              className={classes.cardsContainer}
            >
              {data.map((news) => (
                <NewsCard news={news} />
              ))}
            </Grid>
          )}
        </Grid>
        <FilterDialog
          setData={setData}
          open={newsFilterOpen}
          setNewsFilteropen={setNewsFilteropen}
        />
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
